// src/scripts/vendor/quick-cart-drawer.js
if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
        this.parentElement.addEventListener("shopify:section:select", () => this.open());
        this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
      }
    }
    connectedCallback() {
      this.init();
    }
    init() {
      this.toggleState = false;
      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      this.querySelector(".button--close").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.querySelector(
        ".quick-cart-drawer__backdrop"
      ).addEventListener("click", this.close.bind(this));
      this.querySelector(".quick-cart-drawer__blocks").addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.toggleState) {
          this.close();
        }
        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];
          let isTabPressed = e.key === "Tab";
          if (!isTabPressed) {
            return;
          }
          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });
      this.initTriggers();
    }
    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll(".quick-cart-drawer__trigger").forEach((element) => {
          if (!element._init) {
            element.addEventListener("click", (event) => {
              this.fetchProductForQuickCartDrawer(event);
            });
            element._init = true;
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    async fetchProductForQuickCartDrawer(event) {
      if (event.target.closest("card-product-slider")) {
        event.target.closest("card-product-slider").slider.autoplay.stop();
        event.target.closest("card-product-slider").classList.add("product--open-on-quick-cart");
      }
      const isRecommendations = event.target.classList.contains(
        "quick-cart-drawer__trigger--recommendations"
      );
      const productCard = event.target.closest("product-card");
      let productOptions = null;
      if (!isRecommendations) {
        if (!productCard) return;
        productOptions = productCard.querySelectorAll(
          'input[type="radio"]:checked, select'
        );
      }
      const trigger = event.target.closest("[data-product-url]");
      trigger.classList.toggle("is--loading");
      try {
        let fetchPrefix = "";
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }
        const productUrl = new URL(
          `${fetchPrefix}${trigger.dataset.productUrl}`,
          window.location.origin
        );
        productUrl.searchParams.set("view", "quick-cart");
        const productCardResponse = await fetch(
          `${productUrl.pathname}${productUrl.search}`
        );
        if (!productCardResponse) return;
        const productCardHTML = await productCardResponse.text();
        const productCard2 = document.createElement("DIV");
        productCard2.insertAdjacentHTML("beforeend", productCardHTML);
        if (!productCard2.querySelector(".quick-cart-product")) return;
        this.querySelector(".quick-cart-drawer__main").innerHTML = "";
        this.querySelector(".quick-cart-drawer__main").append(
          productCard2.querySelector(".quick-cart-product")
        );
        this.organiseQuickCartSwatches();
        const drawerRoot = this.querySelector(".quick-cart-drawer__main");
        this.sliderInstance = window.initSwiper(
          drawerRoot.querySelector(".quick-cart-drawer__media-swiper"),
          {
            slidesPerView: 1.25,
            spaceBetween: 8,
            freeMode: { enabled: true },
            breakpoints: {
              750: {
                slidesPerView: 2
              }
            }
          },
          true
        );
        if (window.Alpine) {
          Alpine.initTree(drawerRoot);
        }
        const selectedVariantId = drawerRoot.querySelector(
          ".product-card__add-to-cart--form input[name='image_id_popup']"
        )?.value;
        const selectedVariantColour = drawerRoot.querySelector(
          ".product-card__add-to-cart--form input[name='selected_colour_popup']"
        ).value;
        if (selectedVariantColour) {
          publish(PUB_SUB_EVENTS.productDrawerVariantChange, {
            variant: {
              id: String(selectedVariantId),
              selectedVariantColour
            },
            source: "quick-cart:init"
          });
          this.setInitialSelectedColour(selectedVariantColour);
        }
      } catch (error) {
      } finally {
        trigger.classList.toggle("is--loading");
        if (!isRecommendations) {
          this.querySelector("product-card")?.init();
        }
        setTimeout(() => {
          this.open();
        }, 500);
        this.querySelector(".quick-cart-drawer__main").querySelectorAll(".variant-option-radio-input").forEach((radioInput) => {
          radioInput.addEventListener("change", (event2) => {
            const fieldset = event2.target.closest("fieldset");
            if (!fieldset) return;
            const selectedValue = event2.target.value;
            const selectedValueLabel = event2.target.dataset.selectedValue;
            const groupTitles = fieldset.querySelectorAll(".colour-group-title");
            if (groupTitles.length) {
              const raw = (event2.target.dataset.variantType || "").toLowerCase().trim();
              const type = raw === "save-on" || raw === "save" || raw === "discounted" ? "save" : raw === "new" ? "new" : "regular";
              fieldset.querySelectorAll(".colour-group-title [data-selected-value]").forEach((span) => span.innerHTML = "");
              const groupTitle = fieldset.querySelector(
                `.colour-group-title--${type}`
              );
              if (groupTitle) {
                const span = groupTitle.querySelector("[data-selected-value]");
                if (span) span.innerHTML = selectedValueLabel;
              }
            } else {
              const legend = fieldset.querySelector("legend");
              const span = legend?.querySelector("[data-selected-value]");
              if (span) {
                span.innerHTML = selectedValueLabel;
              }
            }
            const selectedVariantId = this.querySelector(
              ".product-card__add-to-cart--form input[name='id']"
            )?.value;
            if (!selectedVariantId) return;
            publish(PUB_SUB_EVENTS.productDrawerVariantChange, {
              variant: {
                id: String(selectedVariantId),
                selectedVariantColour: selectedValue,
                selectedName: event2.target.name
              },
              source: "quick-cart"
            });
            const productVariantsData = this.querySelector("product-card")?.variantsObj;
            if (!productVariantsData) return;
            const featuredMedia = productVariantsData.find(
              (variant) => variant.id == selectedVariantId
            )?.featured_media;
            if (featuredMedia) {
              this.setActiveMedia(featuredMedia.id);
            }
          });
        });
      }
    }
    setInitialSelectedColour(colour) {
      if (!colour) return;
      const root = this.querySelector(".quick-cart-drawer__main");
      if (!root) return;
      const fieldsets = root.querySelectorAll(
        ".product-card__quick-cart .product__variant-options"
      );
      fieldsets.forEach((fieldset) => {
        const input = fieldset.querySelector(
          `input[value="${CSS.escape(colour)}"]`
        );
        if (!input) return;
        const selectedLabel = input.dataset.selectedValue || input.value;
        const groupTitles = fieldset.querySelectorAll(".colour-group-title");
        if (groupTitles.length) {
          const raw = (input.dataset.variantType || "").toLowerCase().trim();
          const type = raw === "save-on" || raw === "save" || raw === "discounted" ? "save" : raw === "new" ? "new" : "regular";
          fieldset.querySelectorAll("[data-selected-value]").forEach((span2) => span2.innerHTML = "");
          const groupTitle = fieldset.querySelector(
            `.colour-group-title--${type}`
          );
          const span = groupTitle?.querySelector("[data-selected-value]");
          if (span) span.innerHTML = selectedLabel;
        } else {
          const legend = fieldset.querySelector("legend");
          const span = legend?.querySelector("[data-selected-value]");
          if (span) {
            span.innerHTML = selectedLabel;
          }
        }
      });
    }
    organiseQuickCartSwatches() {
      const root = this.querySelector(".quick-cart-drawer__main");
      if (!root) return;
      const fieldsets = root.querySelectorAll(
        ".product-card__quick-cart .product__variant-options[data-colour-options]"
      );
      fieldsets.forEach((fieldset) => {
        const inputs = Array.from(
          fieldset.querySelectorAll("input[data-variant-type]")
        );
        if (!inputs.length) return;
        fieldset.querySelectorAll(".colour-group-title").forEach((el) => el.remove());
        const save = [];
        const newly = [];
        const regular = [];
        inputs.forEach((input) => {
          const raw = (input.dataset.variantType || "").toLowerCase().trim();
          const type = raw === "save-on" || raw === "save" || raw === "discounted" ? "save" : raw === "new" ? "new" : "regular";
          const wrapper = input.closest(".button--variant");
          if (!wrapper) return;
          if (type === "save") save.push(wrapper);
          else if (type === "new") newly.push(wrapper);
          else regular.push(wrapper);
        });
        if (!save.length && !newly.length) return;
        [...save, ...newly, ...regular].forEach((el) => el.remove());
        const insertTitle = (text, type) => {
          const wrapper = document.createElement("div");
          wrapper.className = `colour-group-title colour-group-title--${type}`;
          const label = document.createElement("span");
          label.textContent = text + ":";
          const selected = document.createElement("span");
          selected.setAttribute("data-selected-value", "");
          selected.className = "selected-value";
          wrapper.appendChild(label);
          wrapper.appendChild(selected);
          fieldset.appendChild(wrapper);
        };
        if (save.length) {
          insertTitle("Save on selected colours", "save");
          save.forEach((el) => fieldset.appendChild(el));
        }
        if (newly.length) {
          insertTitle("New Colours", "new");
          newly.forEach((el) => fieldset.appendChild(el));
        }
        if (regular.length) {
          insertTitle("More Colours", "regular");
          regular.forEach((el) => fieldset.appendChild(el));
        }
        const legend = fieldset.querySelector("legend");
        if ((save.length || newly.length) && legend) {
          legend.remove();
        }
      });
    }
    setActiveMedia(id) {
      const slides = Array.from(
        this.querySelectorAll(
          ".quick-cart-drawer__media-swiper .swiper-slide[data-media-id]"
        )
      );
      const index = slides.findIndex(
        (slide) => Number(slide.dataset.mediaId) === id
      );
      const swiper = this.sliderInstance || this.querySelector(".quick-cart-drawer__media-swiper")?.swiper;
      if (index >= 0 && swiper) {
        swiper.slideTo(index);
      }
    }
    /** Drawer coreß functions */
    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }
    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      const quickCartDrawer = document.querySelector(".quick-cart-drawer__blocks");
      const closeButton = quickCartDrawer.querySelector(".button--close");
      quickCartDrawer.setAttribute("tabindex", "0");
      closeButton.setAttribute("tabindex", "0");
      this.classList.add("is--open");
      this.opened();
      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }
    close() {
      this.toggleState = false;
      const shopTheLookDrawer = document.querySelector("shop-the-look-drawer");
      if (shopTheLookDrawer && !shopTheLookDrawer.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      if (!shopTheLookDrawer) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      this.classList.remove("is--open");
      this.closed();
      this.toggleAriaExpanded();
      if (document.querySelector("card-product-slider.product--open-on-quick-cart")) {
        document.querySelector("card-product-slider.product--open-on-quick-cart").slider.autoplay.start();
        document.querySelector("card-product-slider.product--open-on-quick-cart").classList.remove("product--open-on-quick-cart");
      }
    }
    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target.closest("button").setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute(
          "aria-expanded",
          true
        );
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach((button) => {
          button.setAttribute("aria-expanded", false);
        });
      }
    }
    opened() {
      const openedEvent = new Event("opened", { bubbles: true });
      this.dispatchEvent(openedEvent);
    }
    closed() {
      const closedEvent = new Event("closed", { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }
  customElements.define("quick-cart-drawer", QuickCartDrawer);
}
